import { render, staticRenderFns } from "./CostBearerDepositInvoicePdfPreview.vue?vue&type=template&id=12cb5c3f&scoped=true"
import script from "./CostBearerDepositInvoicePdfPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerDepositInvoicePdfPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb5c3f",
  null
  
)

export default component.exports